import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=28eb1896&scoped=true"
import script from "./UploadComponent.vue?vue&type=script&lang=js"
export * from "./UploadComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadComponent.vue?vue&type=style&index=0&id=28eb1896&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb1896",
  null
  
)

export default component.exports